var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}${_vm.slug}`,"viewBox":"0 0 16 16"}},[_c('circle',{attrs:{"cx":"8","cy":"8","r":"8","fill":_vm.getColor('sign'),"stroke":"none"}}),_c('rect',{attrs:{"x":"5","y":"7","width":"6","height":"2","fill":_vm.getColor('icon'),"stroke":"none"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }